// グラフタイプのレジストリシステム

import { GraphRegistryEntry, BaseGraphConfig } from '../../../types/graph-builder.types';
import logger from '../../utils/logger';

// グラフタイプのレジストリ（シングルトン）
class GraphRegistry {
  // GraphRegistryEntry<any>を使用して、異なる具体的な型を格納可能にする
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private registry = new Map<string, GraphRegistryEntry<any>>();

  // グラフタイプを登録
  register<T extends BaseGraphConfig>(type: string, entry: GraphRegistryEntry<T>): void {
    if (this.registry.has(type)) {
      logger.warn(`[GraphRegistry] Graph type "${type}" is already registered. Overwriting.`);
    }
    this.registry.set(type, entry);
  }

  // グラフタイプを取得
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(type: string): GraphRegistryEntry<any> | undefined {
    return this.registry.get(type);
  }

  // すべてのグラフタイプを取得
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAll(): Map<string, GraphRegistryEntry<any>> {
    return new Map(this.registry);
  }

  // グラフタイプのリストを取得（表示用）
  getTypeList(): Array<{ value: string; label: string; description?: string }> {
    const types: Array<{ value: string; label: string; description?: string }> = [];
    this.registry.forEach((entry, type) => {
      types.push({
        value: type,
        label: entry.name,
        description: entry.description
      });
    });
    return types.sort((a, b) => a.label.localeCompare(b.label));
  }

  // グラフタイプが登録されているかチェック
  has(type: string): boolean {
    return this.registry.has(type);
  }

  // レジストリをクリア（主にテスト用）
  clear(): void {
    this.registry.clear();
  }
}

// シングルトンインスタンス
export const graphRegistry = new GraphRegistry();